import _ from "lodash";
import moment from "moment";

// Helper
import { weekdays } from "./Constant";

/*

  [Table of contents]
  1. Restaurant
    - _calculateTotal
    - _calculateOrder
    - _checkoutIsValid
    - _renderRestaurantProfilePic
    - _renderRestaurantCoverPic
    - _renderCloseTime

  2. Mall
    - _processCheckoutWarning
    - _renderWarningMessage
    - _processOrderSummary

  3. General
    - _replaceText
    - _difference
    - _objectIsEqual

*/

/* ----- 1. Restaurant ----- */
export function _calculateTotal(cart) {
  let value = {
    item_total: [],
    item_delivery_total: [],
    discounted_price: [],
    discounted_delivery_price: [],
    packaging_fee: 0,
    admin_fee: 0,
    admin_delivery_fee: 0,
    cart_total: 0,
    cart_delivery_total: 0,
    order_total: 0,
    order_delivery_total: 0,
    voucher_discount: 0,
    delivery_discount: 0,
  };

  let total = 0;
  let tempTotal = 0;
  let orderTotal = 0;
  let deliveryTotal = 0;
  let tempDeliveryTotal = 0;
  let orderDeliveryTotal = 0;
  let totalQuantity = 0;
  let packagingFee = 0;
  let adminPercent = parseFloat(
    _.has(cart, `restaurantDetail`)
      ? cart.restaurantDetail.RestaurantSetting.no_markup_fee / 100
      : 0
  );
  let adminFee = 0;
  let adminDeliveryFee = 0;
  let restaurantDeliveryDiscount = _.has(cart, `restaurantDetail`)
    ? cart.restaurantDetail.RestaurantSetting.delivery_discount
    : null;
  let deliveryFee = 0;
  let tempDeliveryFee = 0;
  let deliveryDiscount = 0;
  let voucherDiscount = 0;

  cart.items.forEach((cartItem, index) => {
    // Calculate discount price by item
    let discount = parseInt(cartItem.menu_detail.discount);
    let discountLimit = parseInt(cartItem.menu_detail.discount_limit);
    // let discountPercent = parseFloat(
    //   (100 - cartItem.menu_detail.discount_pct) / 100
    // );
    let discountPercent = parseFloat(cartItem.menu_detail.discount_pct);
    let discountPrice = 0;
    let discountDeliveryPrice = 0;
    let currentDiscountLimit = 0;
    let itemTotal = 0;
    let itemDeliveryTotal = 0;
    let itemPrice = parseFloat(cartItem.item_price);
    let itemDeliveryPrice = parseFloat(cartItem.delivery_price);
    let quantity = parseInt(cartItem.quantity);
    let previousSameItemRow = [];
    let previousSameItemQuantity = 0;

    itemTotal = itemPrice * quantity;
    itemDeliveryTotal = itemDeliveryPrice * quantity;

    if (discount === 1) {
      // discountPrice = _.round(itemPrice * discountPercent, 2);
      // discountDeliveryPrice = _.round(itemDeliveryPrice * discountPercent, 2);
      // discountPrice = _.round((itemPrice * (100 - discountPercent)) / 100, 2);
      // discountDeliveryPrice = _.round(
      //   (itemDeliveryPrice * (100 - discountPercent)) / 100,
      //   2
      // );
      discountPrice = _.round(
        (_.round(itemPrice * 100) * (100 - discountPercent)) / 10000,
        2
      );
      discountDeliveryPrice = _.round(
        (_.round(itemDeliveryPrice * 100) * (100 - discountPercent)) / 10000,
        2
      );

      // Check previous cart item row has entitled discounted price
      previousSameItemRow = _.filter(
        cart.items,
        (cartItemRow, cartItemIndex) =>
          cartItemRow.item_id === cartItem.item_id && cartItemIndex < index
      );
      previousSameItemQuantity = _.sumBy(
        previousSameItemRow,
        (itemRow) => itemRow.quantity
      );

      if (
        discountLimit === 0 ||
        quantity + previousSameItemQuantity <= discountLimit
      ) {
        itemTotal = discountPrice * quantity;
        itemDeliveryTotal = discountDeliveryPrice * quantity;
      } else {
        currentDiscountLimit =
          previousSameItemQuantity > discountLimit
            ? 0
            : discountLimit - previousSameItemQuantity;

        itemTotal =
          itemPrice * (quantity - currentDiscountLimit) +
          discountPrice * currentDiscountLimit;
        itemDeliveryTotal =
          itemDeliveryPrice * (quantity - currentDiscountLimit) +
          discountDeliveryPrice * currentDiscountLimit;
      }
    }

    // Calculate additional charges per item
    cartItem.option.forEach((optionRow) => {
      optionRow.opt.forEach((option) => {
        let itemCharge = option.charge;
        let subtotal = parseFloat(itemCharge) * parseInt(option.qty);
        subtotal = parseFloat(subtotal);
        itemTotal += subtotal * quantity;
        itemDeliveryTotal += subtotal * quantity;
      });
    });

    // Push Total & Discount Value
    value.discounted_price.push(discountPrice);
    value.item_total.push(parseFloat(itemTotal.toFixed(2)));

    value.discounted_delivery_price.push(discountDeliveryPrice);
    value.item_delivery_total.push(parseFloat(itemDeliveryTotal.toFixed(2)));

    totalQuantity += quantity;
    total += itemTotal;
    deliveryTotal += itemDeliveryTotal;
  });

  cart.voucher !== undefined &&
    cart.voucher.forEach((voucher) => {
      voucherDiscount += parseFloat(
        JSON.parse(voucher.SpecialPackage.package_menu).price
      );
    });

  packagingFee =
    totalQuantity *
    parseFloat(cart.restaurantDetail.RestaurantSetting.packaging);

  total = total + packagingFee;
  deliveryTotal = deliveryTotal + packagingFee;

  adminFee = _.round(total * adminPercent, 2);
  adminDeliveryFee = _.round(deliveryTotal * adminPercent, 2);

  deliveryFee =
    !_.isNil(cart.deliveryFee) && !_.isNaN(cart.deliveryFee)
      ? cart.deliveryFee
      : 0;

  // Delivery Discount
  if (
    deliveryFee > 0 &&
    !_.isNil(restaurantDeliveryDiscount) &&
    restaurantDeliveryDiscount.length > 0
  ) {
    // Sort according by spend
    restaurantDeliveryDiscount = _.sortBy(
      restaurantDeliveryDiscount,
      (spendRow) => parseFloat(spendRow.spend)
    );

    if (deliveryTotal >= parseFloat(restaurantDeliveryDiscount[0].spend)) {
      // Check by descending spend amount
      let index = restaurantDeliveryDiscount.length - 1;
      for (index; index >= 0; index--) {
        if (
          deliveryTotal >= parseFloat(restaurantDeliveryDiscount[index].spend)
        ) {
          if (restaurantDeliveryDiscount[index].discount) {
            // let deliveryDiscountPercent = parseFloat(
            //   (100 - restaurantDeliveryDiscount[index].discount) / 100
            // );
            // deliveryDiscount =
            //   parseFloat(deliveryFee) -
            //   _.round(deliveryFee * deliveryDiscountPercent, 2);
            let deliveryDiscountPercent = parseFloat(
              restaurantDeliveryDiscount[index].discount
            );
            // deliveryDiscount =
            //   parseFloat(deliveryFee) -
            //   _.round((deliveryFee * (100 - deliveryDiscountPercent)) / 100, 2);
            deliveryDiscount =
              parseFloat(deliveryFee) -
              _.round(
                (_.round(deliveryFee * 100) * (100 - deliveryDiscountPercent)) /
                  10000,
                2
              );
          } else if (restaurantDeliveryDiscount[index].cash) {
            deliveryDiscount = parseFloat(
              restaurantDeliveryDiscount[index].cash
            );
          }
          break;
        }
      }
    }
  }

  // Discount on subtotal only
  tempTotal =
    total - parseFloat(voucherDiscount) > 0
      ? total - parseFloat(voucherDiscount)
      : 0;
  tempDeliveryTotal =
    deliveryTotal - parseFloat(voucherDiscount) > 0
      ? deliveryTotal - parseFloat(voucherDiscount)
      : 0;
  tempDeliveryFee =
    parseFloat(deliveryFee) - parseFloat(deliveryDiscount) > 0
      ? parseFloat(deliveryFee) - parseFloat(deliveryDiscount)
      : 0;

  orderTotal = parseFloat(tempTotal);

  orderDeliveryTotal =
    parseFloat(tempDeliveryTotal) +
    parseFloat(adminDeliveryFee) +
    parseFloat(tempDeliveryFee);

  orderDeliveryTotal = orderDeliveryTotal > 0 ? orderDeliveryTotal : 0;

  value.cart_total = total.toFixed(2);
  value.cart_delivery_total = deliveryTotal.toFixed(2);
  value.admin_fee = adminFee.toFixed(2);
  value.admin_delivery_fee = adminDeliveryFee.toFixed(2);
  value.packaging_fee = packagingFee.toFixed(2);
  value.order_total = orderTotal.toFixed(2);
  value.order_delivery_total = orderDeliveryTotal.toFixed(2);
  value.voucher_discount = voucherDiscount.toFixed(2);
  value.delivery_discount = deliveryDiscount.toFixed(2);

  return value;
}

export function _calculateOrder(cart, restaurantID) {
  let cartItemsTotal = _calculateTotal(cart[restaurantID]);

  cartItemsTotal.item_total.forEach((itemTotal, index) => {
    cart[restaurantID].items[index].total = itemTotal;
    cart[restaurantID].items[index].discounted_price =
      cartItemsTotal.discounted_price[index];
  });

  cartItemsTotal.item_delivery_total.forEach((itemDeliveryTotal, index) => {
    cart[restaurantID].items[index].total_delivery = itemDeliveryTotal;
    cart[restaurantID].items[index].discounted_delivery_price =
      cartItemsTotal.discounted_delivery_price[index];
  });

  cart[restaurantID].packagingFee = cartItemsTotal.packaging_fee;
  cart[restaurantID].adminFee = cartItemsTotal.admin_fee;
  cart[restaurantID].adminDeliveryFee = cartItemsTotal.admin_delivery_fee;
  cart[restaurantID].itemTotal = _.sum(cartItemsTotal.item_total).toFixed(2);
  cart[restaurantID].itemDeliveryTotal = _.sum(
    cartItemsTotal.item_delivery_total
  ).toFixed(2);
  cart[restaurantID].cartTotal = cartItemsTotal.cart_total;
  cart[restaurantID].cartDeliveryTotal = cartItemsTotal.cart_delivery_total;
  cart[restaurantID].orderTotal = cartItemsTotal.order_total;
  cart[restaurantID].orderDeliveryTotal = cartItemsTotal.order_delivery_total;
  cart[restaurantID].voucherDiscount = cartItemsTotal.voucher_discount;
  cart[restaurantID].deliveryDiscount = cartItemsTotal.delivery_discount;
  return cart;
}

export function _checkoutIsValid(cart, restaurantDetail, orderType) {
  if (!_.isNil(cart) && !_.isEmpty(restaurantDetail)) {
    switch (orderType) {
      case "pick-up": {
        if (
          cart.items !== undefined &&
          cart.items.length > 0 &&
          parseFloat(restaurantDetail.RestaurantSetting.min_order_amount) === 0
        ) {
          return true;
        } else if (
          parseFloat(cart.itemTotal !== undefined ? cart.itemTotal : 0) !== 0 &&
          parseFloat(cart.itemTotal !== undefined ? cart.itemTotal : 0) >=
            parseFloat(restaurantDetail.RestaurantSetting.min_order_amount)
        ) {
          return true;
        }
        break;
      }
      case "delivery": {
        if (
          cart.items !== undefined &&
          cart.items.length > 0 &&
          parseFloat(restaurantDetail.RestaurantSetting.min_order_amount) === 0
        ) {
          return true;
        } else if (
          parseFloat(
            cart.itemDeliveryTotal !== undefined ? cart.itemDeliveryTotal : 0
          ) !== 0 &&
          parseFloat(
            cart.itemDeliveryTotal !== undefined ? cart.itemDeliveryTotal : 0
          ) >= parseFloat(restaurantDetail.RestaurantSetting.min_order_amount)
        ) {
          return true;
        }
        break;
      }
      default:
        return false;
    }
  }
}

export function _calculateCartTotalQuantity(cart) {
  let totalQuantity = 0;
  if (!_.isNil(cart) && !_.isEmpty(cart)) {
    if (!_.isNil(cart.orderType) && !_.isNil(cart.items)) {
      cart.items.forEach((cartItem) => {
        totalQuantity += parseInt(cartItem.quantity);
      });
    }
  }
  return totalQuantity;
}

export function _renderRestaurantProfilePic(Media) {
  const index = _.findIndex(Media, (image) => image.type === "profile");

  if (index >= 0) {
    return Media[index].path;
  }

  return require("./../assets/img/lolol-bg-white.png");
}

export function _renderRestaurantCoverPic(Media) {
  const index = _.findIndex(Media, (image) => image.type === "cover");

  if (index >= 0) {
    return Media[index].path;
  }

  return require("./../assets/img/lolol-bg-white.png");
}

export function _renderCloseTime(restaurantDetail) {
  // const todayWeekday = moment().isoWeekday(Number);

  let closeTime = "Closed";
  // Not in business hour
  if (restaurantDetail.next_open_tms) {
    let isToday = moment(restaurantDetail.next_open_tms).isSame(moment());
    let nextOpenWeekday = moment(restaurantDetail.next_open_tms).isoWeekday();
    let time = moment(restaurantDetail.next_open_tms).format("hh:mm A");

    closeTime =
      "Closed until " +
      (isToday ? "today" : weekdays[nextOpenWeekday].name) +
      " " +
      time;
  }

  // Temporary Close
  if (restaurantDetail.temporary_close_to != null) {
    let isToday = moment(restaurantDetail.temporary_close_to).isSame(moment());
    // let nextOpenWeekday = moment(
    //   restaurantDetail.temporary_close_to
    // ).isoWeekday(Number);

    closeTime =
      "Temporary Closed until " +
      (isToday
        ? "today " +
          moment(restaurantDetail.temporary_close_to).format("hh:mm A")
        : moment(restaurantDetail.temporary_close_to).format(
            "DD-MM-YYYY hh:mm A"
          ));
  }

  return closeTime;
}
/* ----- END 1. Restaurant ----- */

/* ----- 2. Mall ----- */
export function _processCheckoutWarning(
  orderCheckOut,
  selectedItem,
  selected_shipping
) {
  let warning = [];

  let checkOutUpdated = _checkingCheckOutUpdated(
    orderCheckOut,
    selectedItem,
    selected_shipping
  );
  if (checkOutUpdated.length !== 0) {
    warning = [...checkOutUpdated];
  }

  return warning;
}

export function _checkingCheckOutUpdated(
  orderCheckOut,
  selectedItem,
  selected_shipping
) {
  let error = [];
  let cases = [];
  orderCheckOut.forEach((o) => {
    let obj = {};

    // case 0 : check stock (stock == 0) && product not available (product variation)
    // case 1 : price changed
    // case 2 : updated stock
    // case 3 : weight
    // case 4 : overweight
    // case 5 : publish
    // case 6 : shipping fee updated
    // case 7 : unsupported_pos_company || pos_company_unavailable || no_shipping_method

    if (o.warning !== undefined && o.warning.length !== 0) {
      o.warning.forEach((w) => {
        //case 0 - check stock (stock == 0) && product not available (product variation)
        let product_name = "-";
        let item_variations = null;
        let selectedProduct = selectedItem.find((x) => x.cart_id === o.cart_id);

        if (selectedProduct !== undefined) {
          let MarketProduct = selectedProduct.MarketProduct
            ? selectedProduct.MarketProduct
            : null;

          if (MarketProduct !== null) {
            product_name = MarketProduct.product_name;
          }

          if (selectedProduct.item_variations !== null) {
            item_variations = selectedProduct.item_variations;
          }
        }

        if (w.warning_type === "deleted") {
          obj.cart_id = o.cart_id;
          obj.warning = "DELETED";
          obj.variant = "danger";
          obj.messageTitle =
            "Product " +
            product_name +
            (item_variations !== null ? "'s " + item_variations : "") +
            " is no longer available";
          obj.message = "Please review your cart and try again";
          cases[0] = true;
        }

        if (w.warning_type === "unavailable") {
          if (
            o.product_product_variations.length !== 0 &&
            !_.isEmpty(o.product_variations_setting)
          ) {
            if (
              o.product_variations_setting[o.variation].stock === 0 ||
              !o.product_variations_setting[o.variation].available
            ) {
              obj.cart_id = o.cart_id;
              obj.warning = "UNAVAILABLE";
              obj.variant = "danger";
              obj.messageTitle =
                "Product " +
                o.product_name +
                "'s " +
                o.variation +
                " is not available.";
              obj.message = "Please review your cart and try again";
              cases[0] = true;
            }
          }
        }

        //case 0 - check stock (stock == 0) product no variation
        if (w.warning_type === "sold_out") {
          if (
            o.product_product_variations.length === 0 &&
            _.isEmpty(o.product_variations_setting)
          ) {
            obj.cart_id = o.cart_id;
            obj.warning = "SOLD OUT";
            obj.variant = "danger";
            obj.messageTitle =
              "Product " + o.product_name + " is already sold out.";
            obj.message = "Please review your cart and try again";
            cases[0] = true;
          }
        }

        //case 1 - price changed
        selectedItem.forEach((s) => {
          if (s.cart_id === o.cart_id) {
            if (w.warning_type === "cart_price_updated") {
              obj.cart_id = o.cart_id;
              obj.warning = "UPDATED";
              obj.variant = "primary";
              let variantion_text =
                o.variation !== null ? "'s " + o.variation : "";
              obj.messageTitle =
                "Product " +
                o.product_name +
                variantion_text +
                " price has changed";
              obj.message =
                "If you agreed with the changes, you can continue checkout. Previous price is RM" +
                Number.parseFloat(s.saved_price).toFixed(2);
              obj.hideOverlay = true;
              cases[1] = true;
            }
          }
        });

        // case 2 :  updated stock (stock !== 0)
        if (w.warning_type === "cart_quantity_updated") {
          obj.cart_id = o.cart_id;
          obj.warning = "UPDATED";
          obj.variant = "primary";
          obj.message =
            "If you agreed with the changes, you can continue checkout.";
          if (
            o.product_product_variations.length !== 0 &&
            !_.isEmpty(o.product_variations_setting)
          ) {
            obj.messageTitle =
              "Product " +
              o.product_name +
              "'s " +
              o.variation +
              " now only left " +
              w.new_quantity;
            obj.hideOverlay = true;

            cases[2] = true;
          } else {
            obj.messageTitle =
              "Product " + o.product_name + " now only left " + w.new_quantity;
            obj.hideOverlay = true;
            cases[2] = true;
          }
        }

        // case 3 :  weight
        if (w.warning_type === "cart_weight_updated") {
          selectedItem.forEach((s) => {
            if (s.cart_id === w.cart_id) {
              obj.cart_id = w.cart_id;
              obj.warning = "UPDATED";
              obj.variant = "primary";
              obj.messageTitle =
                "Product " + w.product_name + " weight has changed";
              obj.message =
                "Previous weight is " + s.MarketProduct.weight + " kg.";
              cases[3] = true;
            }
          });
        }

        // case 4 : overweight
        if (w.warning_type === "over_weight") {
          obj.warning = "OVER WEIGHT";
          obj.messageTitle =
            "The cart weight has exceeded " +
            Number.parseFloat(w.max_weight).toFixed(2) +
            " kg limit";
          obj.variant = "danger";
          cases[4] = true;
        }

        // case 5 : publish
        if (w.warning_type === "unpublished") {
          obj.cart_id = o.cart_id;
          obj.warning = "UNPUBLISHED";
          obj.variant = "danger";
          if (
            o.product_product_variations.length !== 0 &&
            !_.isEmpty(o.product_variations_setting)
          ) {
            obj.messageTitle =
              "Product " +
              o.product_name +
              "'s " +
              o.variation +
              " has been unpublished.";
            cases[5] = true;
          } else {
            obj.messageTitle =
              "Product " + o.product_name + " has been unpublished.";
            cases[5] = true;
          }
        }
        // case 6 : shipping fee updated
        if (w.warning_type === "delivery_fees_updated") {
          obj.warning = "SHIPPING FEE UPDATED";
          obj.variant = "primary";
          obj.messageTitle =
            selected_shipping.shipping_company +
            "'s shipping fee has been updated.";
          obj.message =
            "If you agreed with the changes, you can continue checkout. Previous fee is RM " +
            Number.parseFloat(selected_shipping.shipping_fees).toFixed(2);
          obj.shipping_company = selected_shipping.shipping_company;
          obj.hideOverlay = true;
          cases[6] = true;
        }

        // case 7 : unsupported_pos_company || pos_company_unavailable || no_shipping_method
        if (
          w.warning_type === "pos_company_unavailable" ||
          w.warning_type === "unsupported_pos_company" ||
          w.warning_type === "no_shipping_method"
        ) {
          obj.warning = "SHIPPING UNSUPPORTED";
          obj.message = "Please review your cart and try again";
          obj.variant = "danger";
          if (w.warning_type === "no_shipping_method") {
            obj.noShippingMethod = "no_shipping_method";
          }
          if (
            o.product_product_variations.length !== 0 &&
            !_.isEmpty(o.product_variations_setting)
          ) {
            obj.messageTitle =
              "Product " +
              o.product_name +
              " " +
              o.variation +
              "'s shipping method does not support the product";
          } else {
            obj.messageTitle =
              "Product " +
              o.product_name +
              "'s shipping method does not support the product";
          }

          cases[7] = true;
        }
      });
    }
    // case End
    if (cases.length !== 0 && cases.some((d) => d === true)) {
      if (!_.isEmpty(obj)) {
        error.push(obj);
      }
    }
  });

  return error;
}

export function _processOrderSummary(orderSummary, selectedItems, cartItems) {
  let warning = [];
  selectedItems.forEach((s) => {
    orderSummary.forEach((d) => {
      if (s.cart_id === d.cart_id) {
        let productUpdated = _checkingProductUpdated(
          orderSummary,
          selectedItems,
          cartItems
        );
        if (productUpdated.length !== 0) {
          warning = [...productUpdated];
        }
      }
    });
  });

  return warning;
}

export function _checkingProductUpdated(orderSummary, selectedItem, cartItems) {
  let error = [];
  let cases = [];
  /*
    case 0 :  check stock (stock == 0) - Not available
    case 1 :  price changed
    case 2 :  updated stock
    case 3 :  weight
    case 4 :  publish
  */

  // case 0 - Check Available Cart Item Stock - For Product Variation (when not available only)
  if (cartItems.variations_reselect.length !== 0) {
    cartItems.variations_reselect.forEach((c) => {
      const orderItem = orderSummary.find((x) => x.cart_id === c.cart_id);
      if (orderItem !== undefined) {
        selectedItem.forEach((s) => {
          if (c.cart_id === s.cart_id) {
            if (
              c.MarketProduct.variations !== null &&
              c.MarketProduct.variations.length !== 0 &&
              !_.isEmpty(c.MarketProduct.variations_setting)
            ) {
              if (
                !c.MarketProduct.variations_setting[s.item_variations] ||
                c.MarketProduct.variations_setting[s.item_variations].stock ===
                  0 ||
                !c.MarketProduct.variations_setting[s.item_variations].available
              ) {
                let obj = {};
                obj.cart_id = c.cart_id;
                obj.warning = "UNAVAILABLE";
                obj.variant = "danger";
                obj.messageTitle =
                  "Product " +
                  s.MarketProduct.product_name +
                  "'s " +
                  s.item_variations +
                  " is not available.";
                obj.message = "Please review your cart and try again";
                cases[0] = true;
                error.push(obj);
              }
            }
          }
        });
      }
    });
  }

  // case 0  - Check Available Cart Item Stock - For Non Variation Setting(when not available only)
  if (cartItems.invalid.length !== 0) {
    cartItems.invalid.forEach((c) => {
      const itemWarning = orderSummary.find((x) => x.cart_id === c.cart_id);
      const selected_item = selectedItem.find((x) => x.cart_id === c.cart_id);
      if (itemWarning !== undefined && selected_item !== undefined) {
        let obj = {};
        // let valid = true;
        let product_name = selected_item.MarketProduct.product_name;
        let product_name_variation =
          selected_item.MarketProduct.product_name +
          (selected_item.item_variations !== null
            ? "'s " + selected_item.item_variations
            : "");

        if (itemWarning.warning !== undefined) {
          itemWarning.warning.forEach((warning) => {
            switch (warning.warning_type) {
              case "sold_out":
                // valid = false;
                obj.cart_id = c.cart_id;
                obj.variant = "danger";
                obj.message = "Please review your cart and try again";
                cases[0] = true;
                obj.warning = "SOLD OUT";
                obj.messageTitle = `Product ${product_name_variation} is already sold out`;
                break;
              case "unpublished":
                // valid = false;
                obj.cart_id = c.cart_id;
                obj.variant = "danger";
                obj.message = "Please review your cart and try again";
                cases[0] = true;
                obj.warning = "UNPUBLISHED";
                obj.messageTitle = `Product ${product_name} has been unpublished.`;
                break;
              case "deleted":
                // valid = false;
                obj.cart_id = c.cart_id;
                obj.variant = "danger";
                obj.message = "Please review your cart and try again";
                cases[0] = true;
                obj.warning = "DELETED";
                obj.messageTitle = `Product ${product_name} is no longer available`;
                break;
              case "unavailable":
                // valid = false;
                obj.cart_id = c.cart_id;
                obj.variant = "danger";
                obj.message = "Please review your cart and try again";
                cases[0] = true;
                obj.warning = "UNAVAILABLE";
                obj.messageTitle = `Product ${product_name_variation} is currently unavailable`;
                break;
              default:
                break;
            }
            if (!_.isEmpty(obj)) {
              error.push(obj);
            }
          });
        }

        // if (valid) {
        //   obj.cart_id = c.cart_id;
        //   obj.warning = "UNAVAILABLE";
        //   obj.variant = "danger";
        //   obj.messageTitle =
        //     "Product " + c.MarketProduct.product_name + " is not available.";
        //   cases[0] = true;
        //   if (!_.isEmpty(obj)) {
        //     error.push(obj);
        //   }
        // }

        //   selectedItem.forEach(s => {
        //     if (c.cart_id === s.cart_id) {
        //       // if (
        //       //   c.MarketProduct.variations.length === 0 &&
        //       //   _.isEmpty(c.MarketProduct.variations_setting)
        //       // ) {
        //       //   if (c.MarketProduct.stock === 0) {
        //       //     let obj = {};
        //       //     obj.cart_id = c.cart_id;
        //       //     obj.warning = "UNAVAILABLE";
        //       //     obj.variant = "danger";
        //       //     obj.messageTitle =
        //       //       "Product " +
        //       //       c.MarketProduct.product_name +
        //       //       " is not available.";
        //       //     cases[0] = true;
        //       //     if (!_.isEmpty(obj)) {
        //       //       error.push(obj);
        //       //     }
        //       //   }
        //       // }
        //     }
        //   });
      }
    });
  }

  // Check Cart Item - When item updated price and stock
  orderSummary.forEach((o) => {
    let obj = {};

    // case 1 - price changed
    cartItems.data.forEach((c) => {
      c.item.forEach((c) => {
        selectedItem.forEach((s) => {
          if (c.cart_id === o.cart_id && s.cart_id === o.cart_id) {
            if (s.price !== o.price) {
              obj.cart_id = o.cart_id;
              obj.warning = "UPDATED";
              obj.variant = "primary";
              if (
                c.MarketProduct.variations.length === 0 &&
                _.isEmpty(c.MarketProduct.variations_setting)
              ) {
                obj.messageTitle =
                  "Product " + o.product_name + " price has changed";
              } else {
                obj.messageTitle =
                  "Product " +
                  o.product_name +
                  "'s " +
                  o.cart_variation +
                  " price has changed";
              }

              obj.message =
                "If you agreed with the changes, you can continue checkout. Previous price is RM" +
                Number.parseFloat(c.saved_price).toFixed(2);
              obj.hideOverlay = true;
              cases[1] = true;
            }
          }
        });
      });
    });

    // case 2 - updated stock
    selectedItem.forEach((s) => {
      cartItems.data.forEach((c) => {
        c.item.forEach((c) => {
          if (c.cart_id === s.cart_id && c.cart_id === o.cart_id) {
            if (
              o.product_variations !== null &&
              o.product_variations.length !== 0 &&
              !_.isEmpty(o.product_variations_setting)
            ) {
              if (o.product_variations_setting[s.item_variations]) {
                let title =
                  "Product " + o.product_name + "'s " + o.cart_variation;
                if (
                  s.quantity >
                  o.product_variations_setting[s.item_variations].stock
                ) {
                  // when stock !== 0
                  if (
                    o.product_variations_setting[s.item_variations].stock !== 0
                  ) {
                    obj.cart_id = o.cart_id;
                    obj.warning = "UPDATED";
                    obj.variant = "primary";
                    obj.messageTitle =
                      title +
                      " now only left " +
                      o.product_variations_setting[s.item_variations].stock;
                    obj.message =
                      "If you agreed with the changes, you can continue checkout";
                    obj.hideOverlay = true;
                    cases[2] = true;
                  } else {
                    // when stock === 0
                    obj.cart_id = o.cart_id;
                    obj.warning = "SOLD OUT";
                    obj.variant = "danger";
                    obj.messageTitle = title + " is already sold out ";
                    obj.message = "Please review your cart and try again";
                    cases[2] = true;
                  }
                }
              }
            } else {
              if (s.quantity > c.MarketProduct.stock) {
                // when stock !== 0
                if (c.MarketProduct.stock !== 0) {
                  obj.cart_id = o.cart_id;
                  obj.warning = "UPDATED";
                  obj.variant = "primary";
                  obj.messageTitle =
                    c.MarketProduct.product_name +
                    " now only left " +
                    c.MarketProduct.stock;
                  obj.message =
                    "If you agreed with the changes, you can continue checkout";
                  obj.hideOverlay = true;
                  cases[2] = true;
                } else {
                  // when stock === 0
                  obj.cart_id = o.cart_id;
                  obj.warning = "SOLD OUT";
                  obj.variant = "danger";
                  obj.messageTitle =
                    c.MarketProduct.product_name + " is already sold out ";
                  obj.message =
                    "If you agreed with the changes, you can continue checkout";
                  cases[2] = true;
                }
              }
            }
          }
        });
      });
    });

    // case 3 - weight
    selectedItem.forEach((s, i) => {
      if (o.cart_id === s.cart_id) {
        if (o.product_weight !== undefined) {
          if (o.product_weight !== s.MarketProduct.weight) {
            cases[3] = true;
            if (
              !_.isEmpty(o.product_variations) &&
              o.product_variations.length !== 0 &&
              !_.isEmpty(o.product_variations_setting)
            ) {
              obj = {
                cart_id: s.cart_id,
                warning: "UPDATED",
                variant: "primary",
                messageTitle:
                  "Product " +
                  o.product_name +
                  "'s " +
                  o.cart_variation +
                  " weight has changed.",
                message:
                  "Previous weight is " +
                  Number.parseFloat(s.MarketProduct.weight).toFixed(2) +
                  " kg",
              };
            } else {
              obj = {
                cart_id: s.cart_id,
                warning: "UPDATED",
                variant: "primary",
                messageTitle:
                  "Product " + o.product_name + " weight has changed.",
                message:
                  "Previous weight is " +
                  Number.parseFloat(s.MarketProduct.weight).toFixed(2) +
                  " kg",
              };
            }
          }
        }
      }
    });

    // // case 4 - publish
    // let publishMessage = p => {
    //   let obj = {};
    //   obj.cart_id = p.cart_id;
    //   obj.warning = "UNPUBLISHED";
    //   obj.variant = "danger";
    //   obj.messageTitle =
    //     "Product " + p.MarketProduct.product_name + " has been unpublished.";
    //   obj.message = "Please review your cart and try again";
    //   if (!_.isEmpty(obj)) {
    //     error.push(obj);
    //   }
    // };

    // // Check Product Publish - For Product Variation
    // if (cartItems.variations_reselect.length !== 0) {
    //   cartItems.variations_reselect.forEach(c => {
    //     selectedItem.forEach(s => {
    //       if (c.cart_id === s.cart_id && c.cart_id === o.cart_id) {
    //         if (!c.MarketProduct.publish) {
    //           publishMessage(c);
    //         }
    //       }
    //     });
    //   });
    // }

    // // Check Product Publish - For Product
    // if (cartItems.invalid.length !== 0) {
    //   cartItems.invalid.forEach(c => {
    //     selectedItem.forEach(s => {
    //       if (c.cart_id === s.cart_id && c.cart_id === o.cart_id) {
    //         if (!c.MarketProduct.publish) {
    //           publishMessage(c);
    //         }
    //       }
    //     });
    //   });
    // }

    // case End
    if (cases.length !== 0 && cases.some((d) => d === true)) {
      if (!_.isEmpty(obj)) {
        error.push(obj);
      }
    }
  });

  return error;
}

export function _renderWarningMessage(
  item,
  itemDetail,
  warning,
  selected_shipping
) {
  let messageTitle = "";
  let message = "";
  let hideOverlay = false;

  switch (warning.warning_type) {
    case "sold_out": {
      messageTitle = "Product " + item.product_name + " is already sold out";

      return {
        warning: "SOLD OUT",
        messageTitle: messageTitle,
        message: message,
        variant: "danger",
      };
    }
    case "unpublished": {
      messageTitle = "Product " + item.product_name + " has been unpublished";

      return {
        warning: "UNPUBLISHED",
        messageTitle: messageTitle,
        message: message,
        variant: "danger",
      };
    }
    case "deleted": {
      //Done - shall works the same as unpublished
      messageTitle = "Product " + item.product_name + " is no longer available";

      return {
        warning: "DELETED",
        messageTitle: messageTitle,
        message: message,
        variant: "danger",
      };
    }
    case "unavailable": {
      let variation = itemDetail.item_variations;
      let variationMessage = variation === null ? "" : "'s " + variation;

      messageTitle =
        "Product " +
        item.product_name +
        variationMessage +
        " is currently unavailable";

      message = "Please review your cart and try again";

      return {
        warning: "UNAVAILABLE",
        messageTitle: messageTitle,
        message: message,
        variant: "danger",
      };
    }
    case "price_changed":
    case "cart_price_updated": {
      //Done - manual checking and with proper action
      let variationMessage =
        item.variation === null ? "" : "'s " + item.variation;

      messageTitle =
        "Product " +
        item.product_name +
        variationMessage +
        " price has changed";

      message =
        "If you agreed with the changes, you can continue checkout. Previous price is RM " +
        Number.parseFloat(itemDetail.price).toFixed(2);
      hideOverlay = true;

      return {
        warning: "UPDATED",
        messageTitle: messageTitle,
        message: message,
        variant: "primary",
        hideOverlay,
      };
    }
    case "cart_quantity_updated":
    case "not_enough_stock": {
      let variationMessage =
        item.variation === null ? "" : "'s " + item.variation;

      messageTitle =
        "Product " +
        item.product_name +
        variationMessage +
        " now only left " +
        warning.new_quantity;

      message = "If you agreed with the changes, you can continue checkout";
      hideOverlay = true;
      return {
        warning: "UPDATED",
        messageTitle: messageTitle,
        message: message,
        variant: "primary",
        hideOverlay,
      };
    }
    case "stock_only_left": {
      //Will return this for no option product, hence need to check quantity
      let variationMessage =
        item.variation === null ? "" : "'s " + item.variation;

      if (warning.new_quantity !== 0) {
        messageTitle =
          "Product " +
          item.product_name +
          variationMessage +
          " now only left " +
          warning.new_quantity;
        hideOverlay = true;
        message = "If you agreed with the changes, you can continue checkout";
      } else {
        messageTitle =
          "Product " +
          item.product_name +
          variationMessage +
          " is currently unavailable";

        message = "Please review your cart and try again";
      }

      return {
        warning: warning.new_quantity !== 0 ? "UPDATED" : "UNAVAILABLE",
        messageTitle: messageTitle,
        message: message,
        variant: warning.new_quantity !== 0 ? "primary" : "danger",
        hideOverlay,
      };
    }
    case "unsupported_pos_company":
    case "pos_company_unavailable":
    case "no_shipping_method": {
      messageTitle = "Selected shipping method does not support the product ";
      message = "Please review your cart and try again";

      return {
        warning: "SHIPPING UNSUPPORTED",
        messageTitle: messageTitle,
        message: message,
        noShippingMethod: item.warning === "no_shipping_method",
        variant: "danger",
      };
    }
    case "delivery_fees_updated": {
      messageTitle =
        selected_shipping.shipping_company + "'s shipping fee has been updated";

      message =
        "If you agreed with the changes, you can continue checkout. Previous fee is RM " +
        Number.parseFloat(selected_shipping.shipping_fees).toFixed(2);
      hideOverlay = true;
      return {
        warning: "SHIPPING FEE UPDATED",
        messageTitle: messageTitle,
        message: message,
        variant: "primary",
        shipping_company: selected_shipping.shipping_company,
        hideOverlay,
      };
    }
    case "over_weight": {
      messageTitle =
        "The cart weight has exceeded " +
        Number.parseFloat(item.max_weight).toFixed(2) +
        " kg limit";

      return {
        warning: "OVER WEIGHT",
        messageTitle: messageTitle,
        variant: "danger",
      };
    }
    case "cart_weight_updated": {
      let variationMessage =
        item.variation === null ? "" : "'s " + item.variation;

      messageTitle =
        "Product " +
        item.product_name +
        variationMessage +
        " weight has changed";

      message =
        "Previous weight is " +
        Number.parseFloat(item.previous_weight).toFixed(2) +
        " kg";

      return {
        warning: "UPDATED",
        messageTitle: messageTitle,
        message: message,
        variant: "primary",
      };
    }
    default:
      return null;
  }
}

// export function _updateCartItemInformation(updateItem, data, orderSummary) {
//   let newOrderSummary = _.cloneDeep(orderSummary);
//   let newData = _.cloneDeep(data);

//   orderSummary.items.forEach((item, index) => {
//     let cartID = item.cart_id;

//     const updateIndex = _.findIndex(
//       updateItem,
//       itemRow => itemRow.cart_id === cartID
//     );

//     const cartInfoIndex = _.findIndex(
//       data.cart_info,
//       itemRow => itemRow.cart_id === cartID
//     );

//     if (updateIndex >= 0 && cartInfoIndex >= 0) {
//       updateItem[updateIndex].warning.forEach(warning => {
//         switch (warning.warning_type) {
//           case "price_changed":
//           case "cart_price_updated": {
//             newOrderSummary.items[index].price = warning.new_price;
//             newData.cart_info[cartInfoIndex].price = warning.new_price;
//             break;
//           }
//           case "cart_quantity_updated":
//           case "not_enough_stock":
//           case "stock_only_left": {
//             newOrderSummary.items[index].quantity = warning.new_quantity;
//             newData.cart_info[cartInfoIndex].quantity = warning.new_quantity;
//             break;
//           }

//           default:
//             break;
//         }
//       });
//     }
//   });

//   return { newOrderSummary, newData };
// }

/* ----- END 2. Mall ----- */

/* ----- 3. General   ----- */
export function _replaceText(text, from, to) {
  return text.replace(from, to);
}

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
/*
  Example : _difference(this.props.cart, prevProps.cart)
  Performance is greater than JSON.stringify compare
*/
export function _difference(object, base) {
  return _.transform(object, (result, value, key) => {
    if (!_.isEqual(value, base[key])) {
      result[key] =
        _.isObject(value) && _.isObject(base[key])
          ? _.difference(value, base[key])
          : value;
    }
  });
}

export function _objectIsEqual(object, base) {
  return _.isEmpty(_difference(object, base));
}
/* ----- END 3. General   ----- */
